import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _7mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"7mp"} ref={ref}/>
});

_7mpIcon.displayName = "_7mpIcon";
